import React, { useState, useEffect } from "react";
import GameCard from "./GameCard";
import "./GameBoard.css";
import IMG1 from "../../assets/img/potion.jpg";
import IMG2 from "../../assets/img/ring.avif";
import IMG3 from "../../assets/img/shield.jfif";
import IMG4 from "../../assets/img/sword.webp";
import IMG5 from "../../assets/img/scroll.jpg";
import IMG6 from "../../assets/img/penguin.png";
import { ArrowLeft } from "@mui/icons-material";

const cardImages = [
  { src: IMG1, matched: false },
  { src: IMG6, matched: false },
  { src: IMG2, matched: false },
  { src: IMG5, matched: false },
  { src: IMG3, matched: false },
  { src: IMG4, matched: false },
];

const GameBoard = () => {
  const [cards, setCards] = useState([]);
  const [turns, setTurns] = useState(0);
  const [choiceOne, setChoiceOne] = useState(null);
  const [choiceTwo, setChoiceTwo] = useState(null);
  const [disabled, setDisabled] = useState(false);

  // Shuffle cards
  const shuffleCards = () => {
    const shuffledCards = [...cardImages, ...cardImages]
      .sort(() => Math.random() - 0.5)
      .map((card) => ({ ...card, id: Math.random() }));

    setChoiceOne(null);
    setChoiceTwo(null);
    setCards(shuffledCards);
    setTurns(0);
  };

  // Handle a card choice
  const handleChoice = (card) => {
    choiceOne ? setChoiceTwo(card) : setChoiceOne(card);
  };

  // Compare two selected cards
  useEffect(() => {
    if (choiceOne && choiceTwo) {
      setDisabled(true);
      if (choiceOne.src === choiceTwo.src) {
        setCards((prevCards) =>
          prevCards.map((card) =>
            card.src === choiceOne.src ? { ...card, matched: true } : card
          )
        );
        resetTurn();
      } else {
        setTimeout(() => resetTurn(), 1000);
      }
    }
  }, [choiceOne, choiceTwo]);

  // Reset choices & increase turn
  const resetTurn = () => {
    setChoiceOne(null);
    setChoiceTwo(null);
    setTurns((prevTurns) => prevTurns + 1);
    setDisabled(false);
  };

  // Start a new game automatically
  useEffect(() => {
    shuffleCards();
  }, []);

  return (
    <div className="main-div">
      <button
        style={{
          position: "absolute",
          top: "16px",
          left: "16px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "6px 12px",
          backgroundColor: "#e5e7eb",
          color: "#374151",
          borderRadius: "12px",
          border: "none",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
        }}
      >
        <a
          href="/games"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          <ArrowLeft size={20} />
          <span style={{ fontSize: "16px", fontWeight: "500" }}>Back</span>
        </a>
      </button>
      <div className="gameboard-container">
        <h1>Memory Game</h1>
        <button className="new-game-btn" onClick={shuffleCards}>
          New Game
        </button>
        <p>
          Click on two cards to find matching pairs. Match all pairs to win the
          game!
        </p>
        <div className="card-grid">
          {cards.map((card) => (
            <GameCard
              key={card.id}
              card={card}
              handleChoice={handleChoice}
              flipped={card === choiceOne || card === choiceTwo || card.matched}
              disabled={disabled}
            />
          ))}
        </div>
        <p className="turn-counter">Turns: {turns}</p>
      </div>
    </div>
  );
};

export default GameBoard;
